/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */
import { Box, BoxProps } from '@material-ui/core';
import React from 'react';
import './dots-progress.css';

export type DotsProgressProps = BoxProps & {
  size?: 'xs' | 'sm' | 'md' | 'lg';
};

const DotsProgress: React.FC<DotsProgressProps> = ({
  className,
  size = 'md',
  ...props
}) => (
  <Box className={`${className} dots-progress ${size}`} {...props}>
    {Array.from({ length: 10 }).map((_, index) => (
      <div
        key={index}
        className={`dot dot-${index}`}
        style={
          {
            '--index': index,
            '--x': Math.sin(radians(36 * index)),
            '--y': -Math.cos(radians(36 * index)),
          } as Record<string, unknown>
        }
      />
    ))}
    <div className="dot dot-center" />
  </Box>
);

export default DotsProgress;

const radians = (degress: number) => (degress * Math.PI) / 180;
